<div class="item" [class._details-opened]="isDetailsOpened"
  [class.err]="cartItem.statusCode!=='Ok'">
  <div *ngIf="cartItem.item.gradingGuideUrl"
    (click)="cartItemsService.openGradingGuide($event, cartItem, gradingGuideEmitter)" class="item-grading">Grading
    Guide</div>

  <div class="item-btm-layout" (click)="toggleDetails($event, true)">
    <div class="item-details">

      <div class="item-details-row" *ngFor="let attribute of getVisibleAttributes()">
        <!-- Price Drop  -->
        <ng-container *ngIf="attribute.label == 'Price Drop'">
          <div class="item-details-row__icon">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m10.6712861 3.13274794v8.48762466c0 .1868603-.1058659.2307439-.2364581.0976556 0 0-1.07821477-1.0982979-1.47623663-1.5088114-1.25248847-1.27630402-3.13138727.6383213-1.87889877 1.9146254l4.1125837 4.1187729c.4593082.4579519 1.2017259.4556816 1.6579731-.0048053l4.070058-4.1139676c1.2524885-1.2763041-.6264103-3.19092942-1.8912747-1.901867-.3869588.3989174-1.464571 1.4964728-1.464571 1.4964728-.131032.1335329-.2360799.0889459-.2360799-.0980769v-8.48766201c0-.74534782.5849065-1.23181036 1.3064254-1.08411902 0 0-.4071536-.11393589.0258974.00712936 4.2312922 1.1829152 7.3392954 5.11815114 7.3392954 9.79046577 0 5.607797-4.4771525 10.1538148-10 10.1538148s-10-4.5460178-10-10.1538148c0-4.66409569 3.09707837-8.59370351 7.3169763-9.78419772.4399767-.12412375.04810233-.01320354.04810233-.01320354.71982497-.15930334 1.30620747.33753352 1.30620747 1.083964z"
                fill="#fff" opacity="0.5" fill-rule="evenodd" />
            </svg>
          </div>
          <div class="item-details-row__txt">
            <p>Price Drop</p>
          </div>
        </ng-container>

        <!-- just-launched  -->
        <ng-container *ngIf="attribute.label == 'Just Launched'">
          <div class="item-details-row__icon">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m4.82286086 11.2536583 2.22796607.9320718c-.25120368.6398449-.45158379 1.2988286-.59924604 1.9707216l-.08450906.3875558 3.19405825 3.2244648.38413209-.0833245c.66595723-.1489784 1.31911933-.3511445 1.95331163-.6045872l.9238377 2.247824c.0183916.0452548.0581121.0781408.1056939.0875078.0475817.009367.0966423-.0060415.1305473-.0410011l1.3963201-1.4087655c.4608137-.4648659.7050426-1.1048168.6722311-1.7614414l-.0499371-.9049429c2.5852089-1.9261527 5.2011483-5.30370198 5.9137134-11.1984266.0409661-.29958284-.0590665-.60128253-.2704549-.81569559-.2113885-.21441307-.5098851-.31694489-.8070356-.27721194-5.8407283.72472946-9.1903601 3.36592264-11.09949651 5.96642246l-.89502775-.0465067c-.6493832-.0356489-1.28347095.20715647-1.74588031.66853385l-1.39632011 1.40876552c-.03938129.0337779-.05780582.0862546-.04828012.1375111.0095257.0512566.04554123.0934347.09437596.1105247zm8.95796014-3.43374493c.6756757-.67933509 1.7690696-.6780583 2.4431848.00285297.6741153.68091127.6741153 1.78405139 0 2.46496266-.6741152.6809113-1.7675091.6821881-2.4431848.002853-.3254733-.32723608-.5084175-.77174712-.5084175-1.23533433s.1829442-.90809825.5084175-1.2353343zm-9.37474344 10.20628353c-.36972195-.130904-.76674905-.1629492-1.15239625-.0930134-.06966958.0152038-.14219665-.0067482-.19206604-.0581334-.06230224-.0626108-.07918273-.1578293-.04225453-.2383468.40910067-.8875029 1.4942738-2.6721977 3.45910939-1.2304899.02075897.0187475.03262299.0455266.03262299.0736357 0 .028109-.01186402.0548881-.03262299.0736356-.53349089.4238836-.8351583 1.0786451-.81243935 1.7633791.00296577.0822048.06833297.1481546.14981151.1511468.67574202.0274108 1.32429609-.2702755 1.74780097-.8022406.01860333-.022981.04645659-.0363127.07586609-.0363127s.05726276.0133317.07586609.0363127c.27273377.3274847 1.02371199 1.3971389.19206604 2.4299752-.36306683.4402655-.88327531.7186979-1.44817795.7751117-.80667737.0872001-2.29710984.3526759-2.90595919 1.054152-.04979966.0595295-.12803333.086572-.20355322.0703607-.0755199-.0162113-.13606536-.0730444-.15753094-.1478719-.21511396-.7402317-.54930888-2.3950952 1.21385738-3.8213008z"
                fill="#EB3B44" /></svg>
          </div>
          <div class="item-details-row__txt">
            <p>Just Launched</p>
          </div>
        </ng-container>

        <!-- Today's Deal  -->
        <ng-container *ngIf="attribute.label == 'Today\'s Deals'">
          <div class="item-details-row__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="doorbuster-24x24-white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path class="_icon-fill" d="M5.65288161,22.1989497 C6.65918683,23.0365017 7.82650089,23.6347532 9.07431937,23.9139372 C9.195076,23.9538206 9.27558042,23.7942869 9.195076,23.7145201 C6.498178,21.1220971 8.79255391,17.492705 9.27558042,16.7748033 C9.75860692,16.0170181 10.9661732,14.6609815 10.8856688,12.66681 C10.8856688,12.4673928 11.0869298,12.3078591 11.2479387,12.4275094 C12.7775226,13.225178 13.82408,14.9800489 14.1058455,16.4158524 C14.5486198,15.9771347 14.7096286,15.2991164 14.7096286,14.7008649 C14.7096286,14.5014478 14.9511419,14.341914 15.1524029,14.5014478 C16.6014824,15.8176009 19.0971194,20.2845451 15.0718985,23.7942869 C14.9913941,23.8740538 15.0718985,24.0335875 15.1524029,23.9937041 C16.3599692,23.6746366 17.5272832,23.1162686 18.5335885,22.3584834 C25.0946985,17.2534044 20.8279644,8.19986583 18.050562,5.20860859 C17.6882921,4.84965773 17.0442567,5.0889583 17.0442567,5.60744289 C17.0040045,6.6842955 16.6819869,7.8807984 15.8366905,8.67846699 C15.1926551,5.96639376 13.0592881,2.57630222 10.0001202,1.06073189 C9.59759809,0.861314739 9.11457158,1.18038218 9.15482379,1.61909991 C9.23532821,5.32825888 6.82019567,8.00044869 4.7270808,11.0714728 C2.87547919,13.8234294 1.66791293,18.888625 5.65288161,22.1989497 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero" opacity="0.50999999"></path>
              </g>
          </svg>
          </div>
          <div class="item-details-row__txt">
            <p>{{environment.currentDeal.displaySingularLabel}}</p>
          </div>
        </ng-container>

        <!-- Warranty  -->
        <ng-container *ngIf="attribute.label == 'Warranty'">
          <div class="item-details-row__icon">
            <img src="../../../../../assets/images/new-item-details/Warranty.svg" width="24" height="24" alt="Warranty">
          </div>
          <div class="item-details-row__txt">
            <span>Warranty</span>
            <p>{{ attribute.value }}</p>
          </div>
        </ng-container>

        <!-- Packaging  -->
        <ng-container *ngIf="attribute.label == 'Packaging'">
          <div class="item-details-row__icon">
            <img src="../../../../../assets/images/vendor-icons/packaging.svg" width="24" height="24">
          </div>
          <div class="item-details-row__txt" 
               (click)="triggerPackageDescription($event)"  
               [class.package-descriptions]="itemsService.getPackageDescription(attribute.code)">
            <span>Packaging</span>
            <p>
              {{ attribute.value }}
              <i *ngIf="itemsService.getPackageDescription(attribute.code)">
                <img src="assets/images/new-item-details/info.svg" alt="info">
              </i>
            </p>
            <span *ngIf="itemsService.getPackageDescription(attribute.code)" [class.show-description]="isShowPackageDescription" class="package-descriptions-tooltip" [innerHTML]="itemsService.getPackageDescription(attribute.code)">
            </span>
          </div>
        </ng-container>

        <!-- Condition  -->
        <ng-container *ngIf="attribute.label == 'Condition'">
          <div class="item-details-row__icon">
            <img src="../../../../../assets/images/vendor-icons/icon-condition.svg" width="24" height="24">
          </div>
          <div class="item-details-row__txt">
            <span>Condition</span>
            <p>{{ attribute.value }}</p>
          </div>
        </ng-container>

        <!-- Restrictions  -->
        <ng-container *ngIf="attribute.label == 'Restrictions'">
          <div class="item-details-row__icon">
            <img src="../../../../../assets/images/vendor-icons/icon-restrictions.svg" width="24" height="24">
          </div>
          <div class="item-details-row__txt">
            <p>{{ attribute.description }}</p>
          </div>
        </ng-container>
      </div>


      <div class="item-details-row" *ngIf="cartItem.item.leadTimeDays">
        <!-- Lead time -->
        <div class="item-details-row__icon">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="eta" stroke="none" stroke-width="1" fill-rule="evenodd">
              <path
                d="M12,2 C6.47777778,2 2,6.47777778 2,12 C2,17.5222222 6.47777778,22 12,22 C17.5222222,22 22,17.5222222 22,12 C22,6.47777778 17.5222222,2 12,2 Z M16.12,16.12 C15.9022222,16.3355556 15.6177778,16.4444444 15.3333333,16.4444444 C15.0488889,16.4444444 14.7644444,16.3355556 14.5466667,16.12 L11.2133333,12.7866667 C11.0066667,12.5777778 10.8888889,12.2955556 10.8888889,12 L10.8888889,7.55555556 C10.8888889,6.94222222 11.3866667,6.44444444 12,6.44444444 C12.6133333,6.44444444 13.1111111,6.94222222 13.1111111,7.55555556 L13.1111111,11.54 L16.12,14.5488889 C16.5533333,14.9822222 16.5533333,15.6844444 16.12,16.12 Z"
                id="Shape" fill="#000000" fill-rule="nonzero" class="attribute-icon-fill"></path>
            </g>
          </svg>
        </div>
        <div class="item-details-row__txt">
          <span>Lead time</span>
          <p>{{ cartItem.item.leadTimeDays }} Days</p>
        </div>
      </div>

      <!-- more info  -->
      <div class="item-details-row" *ngIf="cartItem.item.comments[0]">
        <div class="item-details-row__icon">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="info-white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path
                d="M22,12 C22,13.8181818 21.5636364,15.4909091 20.6545455,17.0181818 C19.7454545,18.5454545 18.5454545,19.7454545 17.0181818,20.6545455 C15.4909091,21.5636364 13.8181818,22 12,22 C10.1818182,22 8.50909091,21.5636364 6.98181818,20.6545455 C5.45454545,19.7454545 4.25454545,18.5454545 3.34545455,17.0181818 C2.43636364,15.4909091 2,13.8181818 2,12 C2,10.1818182 2.43636364,8.50909091 3.34545455,6.98181818 C4.25454545,5.45454545 5.45454545,4.25454545 6.98181818,3.34545455 C8.50909091,2.43636364 10.1818182,2 12,2 C13.8181818,2 15.4909091,2.43636364 17.0181818,3.34545455 C18.5454545,4.25454545 19.7454545,5.45454545 20.6545455,6.98181818 C21.5636364,8.50909091 22,10.1818182 22,12 Z M13.09319,16.2216653 L13.1111111,14.7067669 L13.1111111,10.6076302 C13.1111111,10.5407964 13.0872162,10.4739627 13.0394265,10.4294069 C12.9916368,10.384851 12.9199522,10.3625731 12.8482676,10.3625731 L11.1696535,10.3625731 C11.0979689,10.3625731 11.0262843,10.384851 10.9784946,10.4294069 C10.9307049,10.4739627 10.90681,10.5407964 10.90681,10.6076302 L10.8888889,12.1225285 L10.8888889,14.684489 L10.90681,16.1993874 C10.90681,16.2662211 10.9307049,16.3330549 10.9784946,16.3776107 C11.0262843,16.4221665 11.0979689,16.4444444 11.1696535,16.4444444 L12.8064516,16.4444444 C12.8781362,16.4444444 12.9498208,16.4221665 12.9976105,16.3776107 C13.0454002,16.3330549 13.09319,16.288499 13.09319,16.2216653 Z M13.0872162,9.07045391 L13.0872162,7.80061264 C13.0872162,7.73377889 13.0633214,7.66694514 13.0155317,7.62238931 C12.9677419,7.57783347 12.8960573,7.55555556 12.8243728,7.55555556 L11.1756272,7.55555556 C11.1039427,7.55555556 11.0322581,7.57783347 10.9844683,7.62238931 C10.9366786,7.66694514 10.9127838,7.73377889 10.9127838,7.80061264 L10.9127838,9.07045391 C10.9127838,9.13728766 10.9366786,9.20412141 10.9844683,9.24867725 C11.0322581,9.29323308 11.1039427,9.315511 11.1756272,9.315511 L12.8243728,9.315511 C12.8960573,9.315511 12.9677419,9.29323308 13.0155317,9.24867725 C13.0633214,9.20412141 13.0872162,9.13728766 13.0872162,9.07045391 Z"
                id="Combined-Shape" fill="#000000" fill-rule="nonzero" class="attribute-icon-fill"></path>
            </g>
          </svg>
        </div>
        <div class="item-details-row__txt">
          <span>More Info</span>
          <p>{{cartItem.item.comments[0].comment}}</p>
        </div>
      </div>


    </div>
  </div>

  <div class="item-top-layout"
  (swipeleft)="hideDetails()"
  (swiperight)="showDetails()">
    <div class="item-top">
      <!-- logo -->
      <div class="item-top__left">
        <div class="item-logo" (click)="toggleDetails($event, false)" *ngIf="cartItem.item.manufacturerLogoUrl">
          <img
            [src]="( !cartItem.item.manufacturerLogoUrl.includes(imageBaseUrl) ? imageBaseUrl : '') + cartItem.item.manufacturerLogoUrl"
            alt="">
        </div>
        <div class="item-logo" *ngIf="!cartItem.item.manufacturerLogoUrl" (click)="toggleDetails($event, false)">
          <img [src]="imageBaseUrl + '/assets/images/item-placeholder.svg'" alt="">
        </div>

        <div class="item-exw">
          <div class="item-exw__label">EXW</div>
          <div class="item-exw__value">{{ cartItem.item.exwPoint }}</div>
        </div>
      </div>

      <div class="item-top__right">
        <div class="item-attribute-list" *ngIf="isTopAttributes(cartItem.item.attributes)">
          <ng-container *ngFor="let attribute of cartItem.item.attributes">
            <div class="item-attribute" *ngIf="attribute.label === 'Price Drop'">
              <img src="../../../../assets/images/icons/mobile/24-price-drop.svg" alt="price drop">
            </div>
            <div class="item-attribute" *ngIf="attribute.label === 'Just Launched'">
              <img src="../../../../assets/images/icons/mobile/24-just-lauched.svg" alt="just lauched">
            </div>
            <div class="item-attribute" *ngIf="attribute.label === 'Today\'s Deals'">
              <img src="../../../../assets/images/icons/item-filter/doorbuster-24-dark.svg" [alt]="environment.currentDeal.displaySingularLabel">
            </div>
          </ng-container>
        </div>
        <!-- notification bell -->
        <div class="item-notifications" *ngIf="cartItem.item.inventory.availableToSell>0">
          <span
          (click)="openNotificationTooltip($event)"
          [class._active]="cartItem?.item?.notificationInfoObj?.moreInventoryInitialValue || cartItem?.item?.notificationInfoObj?.priceDropInitialValue" class="icon">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <linearGradient id="a" x1="74.588658%" x2="16.243437%" y1="17.361718%" y2="82.294216%"><stop offset="0" stop-color="#fe563b"/><stop offset="1" stop-color="#d8214d"/></linearGradient>
              <path class="icon-path" d="m13.78 19.7181605c0 1.0499261-.8554974 2.2818395-1.9 2.2818395h-.76c-1.0445026 0-1.9-1.2319134-1.9-2.2818395zm-7.3234555-11.87516484c.3382199-6.08957172 3.43591623-5.84158916 5.0434555-5.84158916l.0859603-.00019339c1.6294207-.0065559 4.625209-.1408844 4.9574952 5.84578227.2805236 5.08564232 4.0208377 8.28541732 4.0208377 8.28541732.2595818.2489958.4153299.5878449.4357068.9479333v.9199353c-.0032625.316075-.2585269.570883-.5729843.5719598v.0039997h-17.85403141c-.31599725-.0010972-.57189275-.2583214-.57298429-.5759595v-.923935c.02017979-.3601379.17595983-.6990563.43570681-.9479334 0 0 3.74031413-3.1937753 4.02083769-8.28541724z" fill="url(#a)"/>
            </svg>
          </span>
        </div>

        <!-- delete item -->
        <div class="item-delete" [hidden]="userRole === 'SALES' && cartItem.orderLineNum !== -1"
          [class.disableddiv]="!cartItemsService.allowsEdition(cartItem, userRole)">
          <span class="item-delete-icon" [class.spin]="deleteSpinner && deleteSpinnerItem === cartItem.id"
            (click)="cartItemsService.deleteItem(cartItem, $event, userRole, loading, deleteSpinner, deleteItemEmitter)">
          </span>
        </div>
      </div>
    </div>

    <!-- description -->
    <div class="item-desc">
      <span (click)="toggleDetails($event, false)">{{cartItem.item.description}}</span> -
       <span *ngFor="let attribute of getVisibleAttributes()"
                                        [ngClass]="{'hide': attribute.label!=='Condition'}"> {{ attribute.value }} - </span>
      <span class="copy-number" (click)="cartItemsService.copyText($event, cartItem.itemCode)">{{cartItem.itemCode}}
        <span ngModel="cartItemsService.copied" ngDefaultControl>
           {{ cartItemsService.copied }}
        </span>
      </span>
    </div>

    <!-- message  -->
    <div *ngIf="cartItem.statusMessage" class="line-error col-12">
      <div class="d-flex flex-row">
        <div class="icon">
          <img [src]="imageBaseUrl + '/assets/images/exclamation-mark.svg'" width="24px" height="24px" /> </div>
        <div *ngIf="cartItem.statusCode !== 'RestrictedCountry'" class="align-self-center">
          {{cartItem.statusMessage}}
        </div>
        <div *ngIf="cartItem.statusCode === 'RestrictedCountry'" class="align-self-center">
          Restrictions Notice! This item has territory restrictions, you're not authorized to purchase this item. Please remove from cart.
        </div>
      </div>
    </div>

    <!-- price rules -->
    <div class="item-prices" *ngIf="(cartItem.item.moq <=1 || cartItem.item.prices.length>=1)">
      <div class="item-prices-item" *ngFor="let price of cartItem.item.prices">
        <div class="item-prices-item__qty">{{price.fromQty}}+</div>
        <div class="item-prices-item__price">{{price.unitPrice | CustomCurrency}}</div>
      </div>
    </div>

    <div class="item-btm">
      <div class="item-btm__left">
        <!-- price -->
        <div class="item-price">
          <div class="item-price__label">Price</div>
          <span *ngIf="userRole==='BUYER'" class="attr__value attr_price">{{cartItem.unitPrice |
            CustomCurrency }}
          </span>
          <span class="attr__value attr_price" *ngIf="userRole !=='BUYER'">
            <input [disabled]="isOutOfStock || !cartItemsService.allowsEdition(cartItem, userRole)" type="text"
              (change)="cartItemsService.handlePriceUpdate(cartItem, $event.target.value, handlePriceUpdateEmitter)"
              class="edit-order-input" [ngModel]="cartItem.unitPriceHelper | currency:'USD'"
              onkeypress='return event.charCode ===0 || event.charCode ===46 || (event.charCode >= 48 && event.charCode <= 57)' />

            <span class="original-price hide">{{cartItem.overwrittenPrice?cartItem.overwrittenPrice:cartItem.unitPrice
                | CustomCurrency}}
            </span>
            <span class="warning pop animated zoomIn hide">
              <span (click)="showWarning = !showWarning" class="close"></span>Warning, price is below minimum</span>
          </span>
        </div>

        <!-- Available -->
        <div class="item-available">
          <ng-container *ngIf="cartItem.item.inventory.onHand && cartItem.item.inventory.availableToSell>0">
            <div class="item-available__label">In Stock</div>
            <div class="item-available__value">
              <span>
                {{cartItem.item.inventory.onHand}}
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="cartItem.item.inventory.enRoute && cartItem.item.inventory.availableToSell>0">
            <div class="item-available__label">In Transit</div>
            <div class="item-available__value">
              <span>
                {{ cartItem?.item?.inventory?.enRoute ?? 0 }}
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="cartItem.item.inventory.availableToSell<1">
            <div class="item-available__label">Available</div>
            <div class="item-available__value _bold">
              Sold Out
            </div>
          </ng-container>
        </div>

        <!-- quantity -->
        <div class="item-btm__input">
          <div *ngIf="userRole!=='BUYER' && cartItem.reservedQty !== 0"
            [ngClass]="{'hide': cartItem.reservedQty === 0}">
            Original <br>
            Order QTY: {{ cartItem.reservedQty }}
          </div>
          <input [disabled]="isOutOfStock  || cartItemsService.isQtyEditable(cartItem, userRole)" type="number"
            pattern="\d*" (keyup)="cartItemsService.handleQuantityUpdate(cartItem, searchSubject)"
            [(ngModel)]="cartItem.quantity" (blur)="cartItem.quantity = cartItem.quantity ? cartItem.quantity: 1"
            appOnlyDigits #qty />
          <div class="item-btm__input-moq" *ngIf="cartItem.item.moq > 1 || cartItem.item.mxq > 0">
            <span *ngIf="cartItem.item.moq > 1">MOQ {{cartItem.item.moq}}</span>
            <span *ngIf="cartItem.item.mxq > 0">MXQ {{ cartItem.item.mxq }}</span>
          </div>
        </div>

      </div>
      <div class="item-btm__right">
        <div class="item-total">Total
          <span class="item-total__value">
            {{((cartItem.overwrittenPrice)?cartItem.overwrittenPrice:cartItem.unitPrice) * cartItem.quantity | CustomCurrency}}
          </span>
        </div>
      </div>

    </div>
  </div>
</div>
